import { ActionReducerMap } from '@ngrx/store';

import * as CartReducer from './cart/cart.reducer';
import * as ClaimReducer from './claims/claims.reducer';
import * as ConfigReducer from './config/config.reducer';
import * as HistoryReducer from './history/history.reducer';
import * as PrismicReducer from './prismic/prismic.reducer';
import * as ProductReducer from './product/product.reducer';
import * as RemitReducer from './remit/remit.reducer';
import * as UserReducer from './user/user.reducer';
import * as VehicleReducer from './vehicle/vehicle.reducer';

export interface State {
  cartState: CartReducer.State;
  claimState: ClaimReducer.State;
  configState: ConfigReducer.State;
  historyState: HistoryReducer.State;
  prismicState: PrismicReducer.State;
  productState: ProductReducer.State;
  remitState: RemitReducer.State;
  [UserReducer.featureKey]: UserReducer.State;
  vehicleState: VehicleReducer.State;
}

export const reducers: ActionReducerMap<State> = {
  cartState: CartReducer.reducer,
  claimState: ClaimReducer.reducer,
  configState: ConfigReducer.reducer,
  historyState: HistoryReducer.reducer,
  prismicState: PrismicReducer.reducer,
  productState: ProductReducer.reducer,
  remitState: RemitReducer.reducer,
  [UserReducer.featureKey]: UserReducer.reducer,
  vehicleState: VehicleReducer.reducer,
};
